import styled from 'styled-components'

export const ComunicacaoBox = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;  

    .MuiButtonBase-root.MuiAccordionSummary-root.OficioBox_AccordionSummary {
        padding: 0;
        width: calc(100% - 90px);

        .MuiAccordionSummary-content {
            align-items: center;
            display: flex;
            flex-direction: row;
            flex-grow: initial;
            flex-wrap: wrap;
            gap: 16px;
            justify-content: flex-start;
            margin: 0;
            padding: 12px;
        }
    }  
`

ComunicacaoBox.Accordion = styled.div`
    margin: 28px 0;
`

ComunicacaoBox.Mobile = styled.div`
    // #accordion-expanded #OficioBox {
    //     background: var(--primary-dark);
    //     border-left: 3px solid var(--secondary);
    // }

    // .MuiCollapse-root.MuiCollapse-entered {
    //     border-left: 3px solid var(--primary);
    // }

    // .MuiButtonBase-root.MuiAccordionSummary-root.Mui-expanded .MuiAccordionSummary-content.Mui-expanded {
    //     margin: 0;
    // }

    // #accordion-expanded .check-oficio .MuiIconButton-label svg.MuiSvgIcon-root,
    // #accordion-expanded #OficioBox_DataCriacao,
    // #accordion-expanded #OficioBox_Numero,
    // #accordion-expanded #OficioBox_NumeroProcesso,
    // #accordion-expanded #OficioBox_AssuntoProcessual,
    // #accordion-expanded #OficioBox_NomeInteressado,
    // #accordion-expanded #OficioBox_NomeResponsavel,
    // #accordion-expanded #OficioBox_NomeCriador {
    //     color: var(--white);
    // }

    // #panel1bh-header {
    //     padding: 0 10px !important;
    // }

    // #OficioBox_AssuntoProcessual {
    //     width: 100% !important;
    //     font-size: 15px !important;
    // }

    // .MuiAccordionSummary-content {
    //     flex-wrap: wrap;
    // }

    // #OficioBox_NomeCriador,
    // #OficioBox_NomeInteressado,
    // #OficioBox_NomeResponsavel,
    // #OficioBox_DataCriacao,
    // #OficioBox_Numero, 
    // #OficioBox_NumeroProcesso {
    //     font-size: 13px !important;
    // }

    // .MuiAccordionSummary-content {
    //     margin-top: 0;
    // }

    // .MuiPaper-root.MuiAccordion-root.MuiAccordion-rounded.MuiPaper-elevation1.MuiPaper-rounded {
    //     margin-bottom: 25px;
    //     border-radius: 10px;
    //     overflow: hidden;
    // }
`

ComunicacaoBox.MobileContent = styled.div`
    // display: flex;
    // flex-direction: row;
    // flex-wrap: wrap;
    // align-items: center;
    // justify-content: space-between;
    // width: 100%;
    // padding: 10px 0 0 0;

    // span#skeleton-checkbox-oficio-oficio {
    //     height: 24px;
    //     width: 24px;
    //     position: relative;
    //     transform: scale(1);
    //     margin: 10px 6px 10px 0;
    // }

    // span#skeleton-checkbox-oficio-oficio > .MuiSkeleton-wave::after {
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     width: 100%;
    //     height: 250px;
    // }

    // span#skeleton-checkbox-oficio-oficio > .MuiSkeleton-wave::before {
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     width: 100%;
    //     height: 250px;
    // }

    // span#skeleton-btn-acoes-oficio,
    // span#skeleton-btn-fixado-oficio {
    //     height: 32px;
    //     width: 32px;
    //     position: relative;
    //     transform: scale(1);
    //     border-radius: 100%;
    // }

    // span#skeleton-summary-oficio {
    //     height: 32px;
    //     width: 100px;
    //     position: relative;
    //     transform: scale(1);
    // }

    // .OficioBox_Loading div#panel1bh-header {
    //     cursor: default !important;
    // }

    // .btn-fixado-oficio-skeleton {
    //     background: transparent !important;
    // }
`

ComunicacaoBox.Desktop = styled.div`
    border-top: 1px solid rgba(0,0,0,0.2);
    border-bottom: 1px solid rgba(0,0,0,0.2);
    border-left: 1px solid rgba(0,0,0,0.12);
    border-right: 1px solid rgba(0,0,0,0.12);
    height: 260px;
    margin: 0 0 10px 0;
    overflow-y: auto;

    &:last-child {
        border-bottom: 1px solid rgba(0,0,0,0.12);
    }
    
    .MuiPaper-root.MuiAccordion-root.expandir-off.MuiAccordion-rounded.MuiPaper-elevation1.MuiPaper-rounded {
        box-shadow: 0px 2px 1px -1px rgba(0,0,0,0), 0px 1px 1px 0px rgba(0,0,0,0), 0px 1px 3px 0px rgba(0,0,0,0);
    }
`

ComunicacaoBox.Content = styled.div`
    display: grid;
    grid-template-rows: auto auto;
    padding: 5px;
`

ComunicacaoBox.Documento = styled.div`
    display: grid;
    grid-template-columns: auto auto auto auto auto auto;
    padding: 5px;
    font-weight: 500;
`

ComunicacaoBox.Informacao = styled.div`
    padding: 0 5px 0 5px;
    text-align: center;
    max-width: 160px;
    height: 90px;    
    text-overflow: ellipsis;
    word-wrap: break-word;
`

ComunicacaoBox.Acao = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 10px 4px 10px;
    gap: 8px;
`

ComunicacaoBox.BotaoAcao = styled.button`
    min-width: 0;
    padding: 0;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    border: 2px solid;
    transition: all ease .35s;
    cursor: pointer;

    .MuiButton-root svg {
        font-size: 19px;
    } 
`

ComunicacaoBox.InformacaoNumeroDocumento = styled.div`
    color: #9c27b0;
    font-size: 13px;  
    cursor: pointer;  
    display: block;
`

ComunicacaoBox.NumeroDocumento = styled.div`
    
`

ComunicacaoBox.Anexos = styled.div`
    
`

ComunicacaoBox.Processo = styled.div`
    color: #0062d4;
    font-size: 13px;
    cursor: pointer;
    text-decoration: underline; 
`

ComunicacaoBox.DadoComunicacao = styled.div`
    color: #1b2485;
    font-size: 13px;
`

ComunicacaoBox.NumeroAnexos = styled.div`
   display: inline;
`

ComunicacaoBox.IconInformacao = styled.span`
    &> svg {
        color: ${props => props.color};
        font-size: 15px;
    };    
`

ComunicacaoBox.InfoInicial = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 88px;

    @media (max-width: 600px) {
        width: 100%;
        padding-top: 12px;
        justify-content: space-between;
        padding-right: 9px;
    }
`

ComunicacaoBox.Acoes = styled.div`
    align-items: center;
    border-top: 1px solid rgba(0,0,0,0.12);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: flex-start;
    padding: 12px;
`

ComunicacaoBox.TipoOficio = styled.div`
    -webkit-box-align: center;
    -webkit-box-pack: center;
    align-items: center;
    background-color: var(--secondary) !important;
    border-color: var(--secondary) !important;
    border-radius: 100%;
    color: #fff !important;
    display: flex;
    font-size: 12px !important;
    height: 42px;
    justify-content: center;
    max-height: 32px;
    max-width: 32px;
    width: 42px;
`

ComunicacaoBox.TipoOficioSigla = styled.span`
    // font-size: 13px;
    // text-transform: uppercase;
`

ComunicacaoBox.DataCriacao = styled.div`
    color: #9c27b0;
    font-size: 13px;
    font-weight: 500;
`

ComunicacaoBox.Numero = styled.div`
    color: #864ab8;
    font-size: 13px;
    font-weight: 500;
`

ComunicacaoBox.NumeroProcesso = styled.div`
    color: #00bcd4;
    font-weight: 500;
    font-size: 13px;
`

ComunicacaoBox.AssuntoProcessual = styled.div`
    color: #1b2485;
    font-weight: 500;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
`

ComunicacaoBox.NomeInteressado = styled.div`
    color: #8bc34a;
    font-weight: 500;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 87px;
`

ComunicacaoBox.NomeResponsavel = styled.div`
    color: #9e9e9e;
    font-weight: 500;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 80px;
`

ComunicacaoBox.NomeCriador = styled.div`
    color: rgb(74, 122, 195);
    font-weight: 500;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 80px;
`
ComunicacaoBox.FixedTitle = styled.h3`
    // margin-top: 0;
    // font-weight: 300;
    // font-size: 22px;
`